module.exports = __webpack_public_path__ + "img/gsgc2901_2.411c36e2.svg";